export const SET_WEAKNESSES = "SET_WEAKNESSES";
export const ADD_WEAKNESS = "ADD_WEAKNESS";
export const PUT_WEAKNESS = "PUT_WEAKNESS";
export const DELETE_WEAKNESS = "DELETE_WEAKNESS";
export const SET_RISK_WEAKNESSES = "SET_RISK_WEAKNESSES";
export const SET_INFINITE_WEAKNESSES = "SET_INFINITE_WEAKNESSES";
export const SET_SEARCHED_WEAKNESSES = "SET_SEARCHED_WEAKNESSES";
